import React from 'react';

import classNames from 'classnames';
import { observer } from 'mobx-react';
import { Link } from '@infoods/lifebase-ui';
import CameraAltRoundedIcon from '@mui/icons-material/CameraAltRounded';

import classes from './RecipeRow.module.scss';
import { RecipeRowActions } from './RecipeRowActions/RecipeRowActions';
import {
  GridTableCell,
  GridTableRow,
} from '../../../../shared/components/table-components';
import { TextTruncate } from '../../../../shared/components/ui-components';
import { RecipeListItem } from '../../../interfaces/RecipeListItem';
import { getValueOrDash } from '../../../../shared/utils/stringUtils/getValueOrDash/getValueOrDash';

type RecipeRowProps = {
  recipe: RecipeListItem;
};

const RecipeRow = observer(({ recipe }: RecipeRowProps) => {
  const editHref = recipe.editable
    ? `#!/edit-recipe/${recipe.id}`
    : `#!/add-recipe/${recipe.id}`;

  return (
    <GridTableRow
      variant="row"
      className={classNames({
        [classes.banned]: recipe.banned,
      })}
    >
      <GridTableCell>
        <Link href={editHref} className={classes.nameCell}>
          {recipe.image ? (
            <img src={recipe.image} alt={recipe.name} className={classes.thumbnail} />
          ) : (
            <div className={classes.placeholderContainer}>
              <CameraAltRoundedIcon color="white" fontSize="large" />
            </div>
          )}
          <span>{recipe.name}</span>
        </Link>
      </GridTableCell>
      <GridTableCell className={classes.descriptionCell}>
        <TextTruncate text={getValueOrDash(recipe.description) as string} />
      </GridTableCell>
      <RecipeRowActions recipe={recipe} editHref={editHref} />
    </GridTableRow>
  );
});

export { RecipeRow };
